import customAxios from '../../customHook/customAxios';
import { getAuthHeader } from '../../utils';

export const v2_production_stats = async () => {
    const url = `${process.env.REACT_APP_BASE_URL}/v2/production/stats`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}

export const v2_NewBuildingProductionReports = async (page, limit, payload) => {
    const query = payload ? `?payload=${payload}` : '';
    const url = `${process.env.REACT_APP_BASE_URL}/v2/production/report/${page}/${limit}${query}`;
    return customAxios.get(url, getAuthHeader()).then((res) => {
        return res.data;
    })
}
